import http from "@/utils/axios";
import cookie from "@/utils/cookie";

const state = {
  data: {},
}

/**
 * 所有的更新操作放在这里，其他页面添加的module数据之后应该是在这个下面添加，避免每一个页面都需要写同样的方法
 * @type {{updateOrInsertMemberInfo(*, *=): void}}
 *
 */
const mutations = {
}

const actions = {
  //方法写在这里才有返回值,直接将http.post返回,上层调用者可以直接使用其中的值
  updateOrInsertMemberInfo({commit, state},{flag,editSelf}){
    return http.post(window.config.api.baseUrl + '/eims-api/member/update', {
      token: cookie.getCookie("token"),
      data: {
        flag: flag,
        editSelf: editSelf,
        eimsUser: this.state.basicInfoModule.eimsUser,
        eimsUserInfoBase: this.state.basicInfoModule.eimsUserInfoBase,
        eimsUserInfPapers: this.state.paperInfoModule.eimsUserInfPapers,
        eimsUserInfWorks: this.state.workInfoModule.eimsUserInfWorks,
        eimsUserInfPatents: this.state.patentInfoModule.eimsUserInfPatents,
        eimsUserInfAchis: this.state.achiInfoModule.eimsUserInfAchis,
        eimsUserInfSubjects:this.state.subjectInfoModule.eimsUserInfSubjects,
        eimsUserInfTeachings: this.state.teachingInfoModule.eimsUserInfTeachings,
        eimsUserInfGcps: this.state.gcpInfoModule.eimsUserInfGcps,
        eimsUserInfAwards: this.state.awardInfoModule.eimsUserInfAwards,
        eimsUserInfHonors: this.state.honorInfoModule.eimsUserInfHonors,
        eimsUserInfTalents: this.state.talentInfoModule.eimsUserInfTalents,
        eimsUserInfTeachers: this.state.teacherInfoModule.eimsUserInfTeachers,
        eimsUserInfAppointments: this.state.appointmentInfoModule.eimsUserInfAppointments,
        eimsUserInfStudys: this.state.studyInfoModule.eimsUserInfStudys,
        eimsUserInfGraduates: this.state.graduateInfoModule.eimsUserInfGraduates,
        eimsUserInfMeetings: this.state.meetingInfoModule.eimsUserInfMeetings,
        eimsUserInfTrainings: this.state.trainingInfoModule.eimsUserInfTrainings,
        eimsUserInfLectures: this.state.lectureInfoModule.eimsUserInfLectures,
        eimsUserInfVolunteers: this.state.volunteerInfoModule.eimsUserInfVolunteers,
        eimsUserInfStudios: this.state.studioInfoModule.eimsUserInfStudios,
        eimsUserInfGuides: this.state.guideInfoModule.eimsUserInfGuides,
        eimsUserInfCenters: this.state.centerInfoModule.eimsUserInfCenters,
        //TODO 基地、中心工作室信息
        eimsUserInfAlliances: this.state.allianceInfoModule.eimsUserInfAlliances,
        eimsUserInfArticles: this.state.articleInfoModule.eimsUserInfArticles,
        eimsUserInfLecture2s: this.state.lecture2InfoModule.eimsUserInfLecture2s,
        //TODO 公众号视频号信息(待定)
        eimsUserInfQualitys: this.state.qualityInfoModule.eimsUserInfQualitys,
      }
    })
  },

  //查询用户的所有数据
  findMemberInfo({commit, state,dispatch},{userId,flag}){
    let token = cookie.getCookie("token");
    let obj= {
      token: token,
      data: {
        userId: userId,
      }
    }
    if (flag){
      obj.data.flag=flag
    }
    let result = http.post(window.config.api.baseUrl + '/eims-api/member/findUserInfo', obj)
    //这样是为了复用then,页面中才可以取到response中的数据
    result.then(response =>{
      if (response.data.code == '00000'){
        let data =  response.data.data;
        let eimsUser = data.eimsUser;
        let eimsUserInfoBase = data.eimsUserInfoBase;
        let eimsUserInfPapers = data.eimsUserInfPapers;
        let eimsUserInfWorks = data.eimsUserInfWorks;
        let eimsUserInfPatents = data.eimsUserInfPatents;
        let eimsUserInfAchis = data.eimsUserInfAchis;
        let eimsUserInfSubjects = data.eimsUserInfSubjects;
        let eimsUserInfTeachings = data.eimsUserInfTeachings;
        let eimsUserInfGcps = data.eimsUserInfGcps;
        let eimsUserInfAwards = data.eimsUserInfAwards;
        let eimsUserInfHonors = data.eimsUserInfHonors;
        let eimsUserInfTalents = data.eimsUserInfTalents;
        let eimsUserInfTeachers = data.eimsUserInfTeachers;
        let eimsUserInfAppointments = data.eimsUserInfAppointments;
        let eimsUserInfStudys = data.eimsUserInfStudys;
        let eimsUserInfGraduates = data.eimsUserInfGraduates;
        let eimsUserInfMeetings = data.eimsUserInfMeetings;
        let eimsUserInfTrainings = data.eimsUserInfTrainings;
        let eimsUserInfLectures = data.eimsUserInfLectures;
        let eimsUserInfVolunteers = data.eimsUserInfVolunteers;
        let eimsUserInfStudios = data.eimsUserInfStudios;
        let eimsUserInfGuides = data.eimsUserInfGuides;
        let eimsUserInfCenters = data.eimsUserInfCenters;
        let eimsUserInfArticles = data.eimsUserInfArticles;
        let eimsUserInfLecture2s = data.eimsUserInfLecture2s;
        let eimsUserInfQualitys = data.eimsUserInfQualitys;
        let eimsUserInfAlliances = data.eimsUserInfAlliances;
        dispatch("getBasicInfo", {"eimsUser": eimsUser, "eimsUserInfoBase": eimsUserInfoBase});
        dispatch("getPaperInfo", {"eimsUserInfPapers": eimsUserInfPapers});
        dispatch("getWorksInfo", {"eimsUserInfWorks": eimsUserInfWorks});
        dispatch("getPatentInfo", {"eimsUserInfPatents": eimsUserInfPatents});
        dispatch("getAchisInfo", {"eimsUserInfAchis": eimsUserInfAchis});
        dispatch("getSubjectInfo", {"eimsUserInfSubjects": eimsUserInfSubjects});
        dispatch("getTeachingInfo", {"eimsUserInfTeachings": eimsUserInfTeachings});
        dispatch("getGcpInfo", {"eimsUserInfGcps": eimsUserInfGcps});
        dispatch("getAwardInfo", {"eimsUserInfAwards": eimsUserInfAwards});
        dispatch("getHonorInfo", {"eimsUserInfHonors": eimsUserInfHonors});
        dispatch("getTalentInfo", {"eimsUserInfTalents": eimsUserInfTalents});
        dispatch("getTeacherInfo", {"eimsUserInfTeachers": eimsUserInfTeachers});
        dispatch("getAppointmentInfo", {"eimsUserInfAppointments": eimsUserInfAppointments});
        dispatch("getStudysInfo", {"eimsUserInfStudys": eimsUserInfStudys});
        dispatch("getGraduatesInfo", {"eimsUserInfGraduates": eimsUserInfGraduates});
        dispatch("getMeetingsInfo", {"eimsUserInfMeetings": eimsUserInfMeetings});
        dispatch("getTrainingsInfo", {"eimsUserInfTrainings": eimsUserInfTrainings});
        dispatch("getLecturesInfo", {"eimsUserInfLectures": eimsUserInfLectures});
        dispatch("getVolunteersInfo", {"eimsUserInfVolunteers": eimsUserInfVolunteers});
        dispatch("getStudioInfo", {"eimsUserInfStudios": eimsUserInfStudios});
        dispatch("getGuidesInfo", {"eimsUserInfGuides": eimsUserInfGuides});
        dispatch("getCentersInfo", {"eimsUserInfCenters": eimsUserInfCenters});
        dispatch("getArticlesInfo", {"eimsUserInfArticles": eimsUserInfArticles});
        dispatch("getLecture2sInfo", {"eimsUserInfLecture2s": eimsUserInfLecture2s});
        dispatch("getQualitysInfo", {"eimsUserInfQualitys": eimsUserInfQualitys});
        dispatch("getAllianceInfo", {"eimsUserInfAlliances": eimsUserInfAlliances});
        dispatch("getEimsUser", {"userId": eimsUser.userId});
      }
    })
    return result
  },

  //查询用户自己的所有数据
  findMySelfInfo({commit, state,dispatch},{flag}){
    let token = cookie.getCookie("token");
    let obj= {
      token: token,
      data: {
        flag:flag
      }
    }
    let result = http.post(window.config.api.baseUrl + '/eims-api/member/mySelf/info', obj)
    //这样是为了复用then,页面中才可以取到response中的数据
    result.then(response =>{
      if (response.data.code == '00000'){
        let data =  response.data.data;
        let eimsUser = data.eimsUser;
        let eimsUserInfoBase = data.eimsUserInfoBase;
        let eimsUserInfPapers = data.eimsUserInfPapers;
        let eimsUserInfWorks = data.eimsUserInfWorks;
        let eimsUserInfPatents = data.eimsUserInfPatents;
        let eimsUserInfAchis = data.eimsUserInfAchis;
        let eimsUserInfSubjects = data.eimsUserInfSubjects;
        let eimsUserInfTeachings = data.eimsUserInfTeachings;
        let eimsUserInfGcps = data.eimsUserInfGcps;
        let eimsUserInfAwards = data.eimsUserInfAwards;
        let eimsUserInfHonors = data.eimsUserInfHonors;
        let eimsUserInfTalents = data.eimsUserInfTalents;
        let eimsUserInfTeachers = data.eimsUserInfTeachers;
        let eimsUserInfAppointments = data.eimsUserInfAppointments;
        let eimsUserInfStudys = data.eimsUserInfStudys;
        let eimsUserInfGraduates = data.eimsUserInfGraduates;
        let eimsUserInfMeetings = data.eimsUserInfMeetings;
        let eimsUserInfTrainings = data.eimsUserInfTrainings;
        let eimsUserInfLectures = data.eimsUserInfLectures;
        let eimsUserInfVolunteers = data.eimsUserInfVolunteers;
        let eimsUserInfStudios = data.eimsUserInfStudios;
        let eimsUserInfGuides = data.eimsUserInfGuides;
        let eimsUserInfCenters = data.eimsUserInfCenters;
        let eimsUserInfArticles = data.eimsUserInfArticles;
        let eimsUserInfLecture2s = data.eimsUserInfLecture2s;
        let eimsUserInfQualitys = data.eimsUserInfQualitys;
        let eimsUserInfAlliances = data.eimsUserInfAlliances;
        dispatch("getBasicInfo", {"eimsUser": eimsUser, "eimsUserInfoBase": eimsUserInfoBase});
        dispatch("getPaperInfo", {"eimsUserInfPapers": eimsUserInfPapers});
        dispatch("getWorksInfo", {"eimsUserInfWorks": eimsUserInfWorks});
        dispatch("getPatentInfo", {"eimsUserInfPatents": eimsUserInfPatents});
        dispatch("getAchisInfo", {"eimsUserInfAchis": eimsUserInfAchis});
        dispatch("getSubjectInfo", {"eimsUserInfSubjects": eimsUserInfSubjects});
        dispatch("getTeachingInfo", {"eimsUserInfTeachings": eimsUserInfTeachings});
        dispatch("getGcpInfo", {"eimsUserInfGcps": eimsUserInfGcps});
        dispatch("getAwardInfo", {"eimsUserInfAwards": eimsUserInfAwards});
        dispatch("getHonorInfo", {"eimsUserInfHonors": eimsUserInfHonors});
        dispatch("getTalentInfo", {"eimsUserInfTalents": eimsUserInfTalents});
        dispatch("getTeacherInfo", {"eimsUserInfTeachers": eimsUserInfTeachers});
        dispatch("getAppointmentInfo", {"eimsUserInfAppointments": eimsUserInfAppointments});
        dispatch("getStudysInfo", {"eimsUserInfStudys": eimsUserInfStudys});
        dispatch("getGraduatesInfo", {"eimsUserInfGraduates": eimsUserInfGraduates});
        dispatch("getMeetingsInfo", {"eimsUserInfMeetings": eimsUserInfMeetings});
        dispatch("getTrainingsInfo", {"eimsUserInfTrainings": eimsUserInfTrainings});
        dispatch("getLecturesInfo", {"eimsUserInfLectures": eimsUserInfLectures});
        dispatch("getVolunteersInfo", {"eimsUserInfVolunteers": eimsUserInfVolunteers});
        dispatch("getStudioInfo", {"eimsUserInfStudios": eimsUserInfStudios});
        dispatch("getGuidesInfo", {"eimsUserInfGuides": eimsUserInfGuides});
        dispatch("getCentersInfo", {"eimsUserInfCenters": eimsUserInfCenters});
        dispatch("getArticlesInfo", {"eimsUserInfArticles": eimsUserInfArticles});
        dispatch("getLecture2sInfo", {"eimsUserInfLecture2s": eimsUserInfLecture2s});
        dispatch("getQualitysInfo", {"eimsUserInfQualitys": eimsUserInfQualitys});
        dispatch("getAllianceInfo", {"eimsUserInfAlliances": eimsUserInfAlliances});
        dispatch("getEimsUser", {"userId": eimsUser.userId});
      }
    })
    return result
  },


}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/memberAllInfoModule.js